import { APIService } from 'connectors/api/rest';

export const Priorities = {
  async getList(params) {
    try {
      return await APIService.GET('priorities', params);
    } catch (e) {
      return null;
    }
  },
};
